import type { Ref } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";
import { useIslandHost } from "@frontend/contexts";

import {
  ClientContactModal,
  type ClientContactModalHandle,
} from "./ClientContactModal";
import {
  type ClientContactModalDataProps,
  clientContactModalDataSchema,
} from "./ClientContactModal.schema";
import type { ClientContact } from "./types";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    "client-contact-modal": {
      props: ClientContactModalDataProps;
      handle: ClientContactModalHandle;
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-client-contact-modal": HTMLElement & ClientContactModalHandle;
  }
}

export function RWCClientContactModal({
  ref,
}: ClientContactModalDataProps & {
  ref?: Ref<ClientContactModalHandle>;
}) {
  const host = useIslandHost();

  const handleCreated = (contact: ClientContact) => {
    host?.dispatchEvent(
      new CustomEvent("modal:submit", {
        detail: { contact },
        bubbles: true,
      }),
    );
  };

  return <ClientContactModal ref={ref} onCreated={handleCreated} />;
}

componentManager.register(
  rwc("client-contact-modal", {
    component: RWCClientContactModal,
    dataSchema: clientContactModalDataSchema,
  }),
);
